import { ClientMessagesStatusEnum } from '@tassat/common-definitions';
import { createSelector } from 'reselect';

import { AdminState } from 'Reducers/store/adminStore';
import { ClientState } from 'Reducers/store/clientStore';

import { getMessageAdminValidation } from './common';

const getMessageAdminHistory = (state: AdminState | ClientState) => {
    return state.clientMessage.admin.history;
};

const getSelectedMessageId = (_state: AdminState | ClientState, messageId: string) => messageId;

const getSortBy = (_state: AdminState | ClientState, sortBy: 'StartAt' | 'EndAt') => sortBy;

export const getClientMessageHistoryArray = createSelector(
    [getMessageAdminHistory],
    (history) => Object.values(history)
);

export const getClientMessageById = createSelector(
    [ getMessageAdminHistory, getSelectedMessageId ],
    (history, messageId) => messageId ? history[messageId] : null
);

export const getClientBannerMessage = (state: AdminState | ClientState) => {
    return state.clientMessage.client.banner;
};

export const getClientAdvisoryMessage = (state: AdminState | ClientState) => {
    return state.clientMessage.client.advisory;
};

export const getMessagesForValidation = createSelector(
    [ getMessageAdminValidation, getSortBy ],
    (messageAdminValidation, sortBy) => {
        const messageArr = Object.keys(messageAdminValidation)
            .map(id => messageAdminValidation[id])
            .filter(message => message.Status !== ClientMessagesStatusEnum.CANCELLED);

        if (sortBy) {
            messageArr.sort((a, b) => Number(a[sortBy]) - Number(b[sortBy]));
        }

        return messageArr;
    }
);